'use client';

import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import Link from 'next/link';
import { useLocale, useTranslations } from 'next-intl';

const Content = () => {
  const locale = useLocale();
  const t = useTranslations();

  return (
    <section data-cy="eu-declarations-of-conformity">
      <LayoutGrid>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <Typography Element="h1" variant="h3">
            {t('eu_declarations_of_conformity')}
          </Typography>
          <Typography variant="h6" className="mb-8">
            {t('eu_declaration_page_access')}
          </Typography>
          <Typography className="mb-4 underline">
            <Link href={`/${locale}/declarations-of-conformity/gen3`}>
              {t('eu_declaration_gen_3')}
            </Link>
          </Typography>
          <Typography className="underline">
            <Link href={`/${locale}/declarations-of-conformity/oura-ring-4`}>
              {t('eu_declaration_gen_4')}
            </Link>
          </Typography>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default Content;
